import type { DataResource } from '@/dashboard/features/editToolbox/types/dataResource.types';
import type {
  DisplayStyleType,
  WidgetChartType,
  WidgetType,
} from '@/dashboard/shared/types/widgets.types';

/**
 * DataResource에 따라 WidgetType 필터링
 * @param dataResource - 데이터 리소스
 * @param widgetType - 위젯 타입
 */
export const filterWidgetTypeByDataResource = (
  dataResource: DataResource,
  widgetType: WidgetType,
): boolean => {
  switch (dataResource) {
    case 'prometheus':
    case 'elasticsearch':
      switch (widgetType) {
        case 'GRAPHS':
        case 'LIST':
        case 'GROUP':
          return true;
        default:
          return false;
      }
    case 'default':
      return true;
    default:
      return true;
  }
};

/**
 * DataResource에 따라 ChartType 필터링
 * @param dataResource - 데이터 리소스
 * @param chartType - 차트 타입
 */
export const filterChartTypeByDataResource = (
  dataResource: DataResource,
  chartType: WidgetChartType,
): boolean => {
  switch (dataResource) {
    case 'prometheus':
      switch (chartType) {
        case 'EQUALIZER':
        case 'ACTION_VIEW':
        case 'HEATMAP':
          return false;
        default:
          return true;
      }
    case 'elasticsearch':
      switch (chartType) {
        case 'EQUALIZER':
        case 'ACTION_VIEW':
        case 'SCATTER':
        case 'TOP_LIST':
        case 'HEATMAP':
        case 'ONE_DAY_COMPARE':
          return false;
        default:
          return true;
      }
    case 'default':
      return true;
    default:
      return true;
  }
};

/**
 * DataResource에 따라 DisplayStyle 필터링
 * @param dataResource - 데이터 리소스
 * @param chartType - 차트 타입
 * @param displayStyle - 디스플레이 스타일
 */
export const filterDisplayStyleByDataResource = (
  dataResource: DataResource,
  chartType: WidgetChartType,
  displayStyle: DisplayStyleType,
): boolean => {
  switch (dataResource) {
    case 'prometheus':
      switch (chartType) {
        case 'SCOREBOARD':
          return ['STYLE_1'].includes(displayStyle);
        default:
          return true;
      }
    case 'elasticsearch':
      switch (chartType) {
        case 'SCOREBOARD':
          return ['STYLE_1'].includes(displayStyle);
        case 'STACKED_PROPORTION_BAR':
          return ['SINGLE_STACK'].includes(displayStyle);
        default:
          return true;
      }
    case 'default':
      return true;
    default:
      return true;
  }
};

/**
 * DataResource가 legend에 유효한지 확인
 * @param dataResource - 데이터 리소스
 */
export const isLegendValidDataResource = (dataResource: DataResource) => {
  switch (dataResource) {
    case 'default':
      return true;
    default:
      break;
  }
  return false;
};
